(() => {
  if (window.SaleBanner) return;

  const pad = (n) => String(n).padStart(2, "0");

  function startCountdown(root) {
    const deadline = Date.parse(root.dataset.deadline || "");
    const timer = root.querySelector(".sale-banner__countdown");
    if (!timer || Number.isNaN(deadline)) return;
    const units = {
      days: timer.querySelector('[data-unit="days"]'),
      hrs: timer.querySelector('[data-unit="hrs"]'),
      mins: timer.querySelector('[data-unit="mins"]'),
      secs: timer.querySelector('[data-unit="secs"]'),
    };

    const expire = () => {
      clearInterval(root._saleBannerTimer);
      const mode = root.dataset.onExpire;
      if (mode === "hide_banner") {
        (root.closest(".shopify-section") || root).style.display = "none";
        return;
      }
      timer.hidden = true;
      if (mode === "message") {
        const note = root.querySelector(".sale-banner__expired");
        if (note) note.hidden = false;
      }
    };

    const tick = () => {
      const left = Math.max(0, deadline - Date.now());
      if (left === 0) return expire();
      const s = Math.floor(left / 1000);
      const days = Math.floor(s / 86400);
      units.days.textContent = pad(days);
      units.days.parentElement.classList.toggle("is-empty", days === 0);
      units.hrs.textContent = pad(Math.floor((s % 86400) / 3600));
      units.mins.textContent = pad(Math.floor((s % 3600) / 60));
      units.secs.textContent = pad(s % 60);
    };

    clearInterval(root._saleBannerTimer);
    tick();
    root._saleBannerTimer = setInterval(tick, 1000);
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    const field = document.createElement("textarea");
    field.value = text;
    field.setAttribute("readonly", "");
    field.style.position = "fixed";
    field.style.opacity = "0";
    document.body.appendChild(field);
    field.select();
    document.execCommand("copy");
    field.remove();
    return Promise.resolve();
  }

  function bindCode(root) {
    const chip = root.querySelector(".sale-banner__code");
    if (!chip || chip._saleBannerBound) return;
    chip._saleBannerBound = true;
    const action = chip.querySelector(".sale-banner__code-action");
    const original = action ? action.textContent : "";
    chip.addEventListener("click", () => {
      copyText(chip.dataset.code).then(() => {
        chip.classList.add("is-copied");
        if (action) action.textContent = chip.dataset.copied;
        clearTimeout(chip._saleBannerReset);
        chip._saleBannerReset = setTimeout(() => {
          chip.classList.remove("is-copied");
          if (action) action.textContent = original;
        }, 2000);
      });
    });
  }

  function bindDismiss(root) {
    const key = root.dataset.dismissKey;
    const button = root.querySelector("[data-sale-banner-close]");
    if (!key || !button) return;
    const designMode = window.Shopify && window.Shopify.designMode;
    try {
      if (!designMode && sessionStorage.getItem(key)) root.classList.add("is-dismissed");
    } catch (e) {}
    if (button._saleBannerBound) return;
    button._saleBannerBound = true;
    button.addEventListener("click", () => {
      root.classList.add("is-dismissed");
      try {
        sessionStorage.setItem(key, "1");
      } catch (e) {}
    });
  }

  function init(scope = document) {
    scope.querySelectorAll("[data-sale-banner]").forEach((root) => {
      if (root.dataset.deadline) startCountdown(root);
      bindCode(root);
      bindDismiss(root);
    });
  }

  window.SaleBanner = { init };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
